"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  border: ", ";\n  border-radius: ", ";\n  \n  [role=\"tablist\"],\n  [role=\"tabpanel\"] {\n    margin: 0;\n  }\n  \n  [role=\"tab\"],\n  [role=\"tabpanel\"] > div {\n    margin: 0;\n  }\n  \n  [role=\"tablist\"] {\n    border-bottom: ", ";\n    border-left: ", ";\n    border-right: ", ";\n    display: ", ";\n    list-style-type: none;\n    margin-left: ", ";\n    padding: 0;\n  }\n  \n  [role=\"tab\"] {\n    color: ", ";\n    cursor: pointer;\n    font-size: .9em;\n    font-weight: ", ";\n    line-height: 1.15;\n    \n    &:not(:last-of-type) {\n      border-bottom: ", ";\n      border-right: ", ";\n      margin-bottom: -1px;\n    }\n      \n    &:hover,\n    &[aria-selected=\"true\"] {\n      color: ", ";\n    }\n    \n    &[aria-selected=\"true\"] {\n      color: ", ";\n    }\n  }\n  \n  [role=\"tabpanel\"] {\n    border-left: ", ";\n    border-right: ", ";\n    margin-left: ", ";\n  }\n"], ["\n  border: ", ";\n  border-radius: ", ";\n  \n  [role=\"tablist\"],\n  [role=\"tabpanel\"] {\n    margin: 0;\n  }\n  \n  [role=\"tab\"],\n  [role=\"tabpanel\"] > div {\n    margin: 0;\n  }\n  \n  [role=\"tablist\"] {\n    border-bottom: ", ";\n    border-left: ", ";\n    border-right: ", ";\n    display: ", ";\n    list-style-type: none;\n    margin-left: ", ";\n    padding: 0;\n  }\n  \n  [role=\"tab\"] {\n    color: ", ";\n    cursor: pointer;\n    font-size: .9em;\n    font-weight: ", ";\n    line-height: 1.15;\n    \n    &:not(:last-of-type) {\n      border-bottom: ", ";\n      border-right: ", ";\n      margin-bottom: -1px;\n    }\n      \n    &:hover,\n    &[aria-selected=\"true\"] {\n      color: ", ";\n    }\n    \n    &[aria-selected=\"true\"] {\n      color: ", ";\n    }\n  }\n  \n  [role=\"tabpanel\"] {\n    border-left: ", ";\n    border-right: ", ";\n    margin-left: ", ";\n  }\n"]);

var _arenaConfig = require("arena-config");

var c = _interopRequireWildcard(_arenaConfig);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactTabs = require("react-tabs");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var makeTabsProps = function makeTabsProps(_ref) {
  var bordered = _ref.bordered,
      inlineLinks = _ref.inlineLinks,
      sidebarOnRight = _ref.sidebarOnRight,
      sidebarWidth = _ref.sidebarWidth,
      rest = _objectWithoutProperties(_ref, ["bordered", "inlineLinks", "sidebarOnRight", "sidebarWidth"]);

  return _react2.default.createElement(_reactTabs.Tabs, rest);
};

var StyledTabs = (0, _styledComponents2.default)(makeTabsProps)(_templateObject, function (props) {
  return props.bordered ? c.SOLID_BORDER : undefined;
}, c.BORDER_RADIUS, function (props) {
  return props.bordered && props.sidebarWidth === 12 ? c.SOLID_BORDER : undefined;
}, function (props) {
  return props.bordered && props.sidebarWidth < 12 && props.sidebarOnRight ? c.SOLID_BORDER : undefined;
}, function (props) {
  return props.bordered && props.sidebarWidth < 12 && !props.sidebarOnRight ? c.SOLID_BORDER : undefined;
}, function (props) {
  return props.inlineLinks ? 'flex' : undefined;
}, function (props) {
  return props.bordered && props.sidebarOnRight && props.sidebarWidth < 12 ? '-1px' : undefined;
}, c.LIGHT_GRAY, c.FONT_WEIGHT_3, function (props) {
  return props.bordered && !props.inlineLinks ? c.DASHED_BORDER : undefined;
}, function (props) {
  return props.bordered && props.inlineLinks ? c.DASHED_BORDER : undefined;
}, c.DARK_GRAY, c.BLUE, function (props) {
  return props.bordered && !props.sidebarOnRight && props.sidebarWidth < 12 ? c.SOLID_BORDER : undefined;
}, function (props) {
  return props.bordered && props.sidebarOnRight && props.sidebarWidth < 12 ? c.SOLID_BORDER : undefined;
}, function (props) {
  return props.bordered && !props.sidebarOnRight && props.sidebarWidth < 12 ? '-1px' : undefined;
});
exports.default = StyledTabs;